import ImageQualityStatus from '../../../enums/ImageQualityStatus.js';
import { isAliasingReduction } from '../../../utilities/voxelGrid/index.js';
export function lineHasData(line) {
    return (!!line.record ||
        line.imageQualityStatus !== undefined ||
        !line.fullResolution);
}
export const FIDELITY_STATE_ORDER = [
    'loading',
    'lod',
    'lossy',
    'done',
];
export function fidelityStateRank(state) {
    return FIDELITY_STATE_ORDER.length - FIDELITY_STATE_ORDER.indexOf(state);
}
export function svgStateOf(lines) {
    let worst = 'hidden';
    let worstRank = 0;
    for (const line of lines) {
        if (!lineHasData(line)) {
            continue;
        }
        const kind = lineKind(line);
        const rank = fidelityStateRank(kind);
        if (rank > worstRank) {
            worst = kind;
            worstRank = rank;
        }
    }
    return worst;
}
export function dataKindOf(line) {
    const { record, reductionFactors, fullResolution, verdict, imageQualityStatus, } = line;
    if (!record && imageQualityStatus !== undefined) {
        return dataKindOfImageQuality(imageQualityStatus);
    }
    if (!record) {
        return fullResolution ? 'loading' : 'reduced';
    }
    const lowest = record.lowest ?? ImageQualityStatus.FULL_RESOLUTION;
    const lossyDelivery = lowest < ImageQualityStatus.FULL_RESOLUTION;
    if (lossyDelivery && record.missing > 0) {
        return 'loading';
    }
    if (isAliasingReduction(record.reduction)) {
        return 'decimated';
    }
    if (lossyDelivery) {
        return 'reduced';
    }
    const spatiallyReduced = !fullResolution || isReduced(reductionFactors);
    if (!spatiallyReduced) {
        return 'full';
    }
    if (verdict) {
        if (verdict.causes.includes('aliasing')) {
            return 'decimated';
        }
        return verdict.causes.includes('resolution') ? 'reduced' : 'full';
    }
    return 'reduced';
}
export function dataKindOfImageQuality(status) {
    if (status >= ImageQualityStatus.FULL_RESOLUTION) {
        return 'full';
    }
    if (status >= ImageQualityStatus.SUBRESOLUTION) {
        return 'reduced';
    }
    return 'loading';
}
export function lineKind(line) {
    const dataKind = dataKindOf(line);
    if (dataKind === 'loading') {
        return 'loading';
    }
    if (isInteractiveLod(line.sampleDistanceLod) || line.interactiveReduction) {
        return 'lod';
    }
    return dataKind === 'full' ? 'done' : 'lossy';
}
export function reductionFactorsOf(drawn, full) {
    const factors = [1, 1, 1];
    for (let axis = 0; axis < 3; axis++) {
        const fullSpacing = full.spacing[axis];
        if (!(fullSpacing > 0)) {
            continue;
        }
        factors[axis] = drawn.spacing[axis] / fullSpacing;
    }
    return factors;
}
export function isReduced(factors) {
    return factors.some((factor) => factor > 1 + 1e-6);
}
export function formatFactors(factors) {
    return factors.map(formatFactor).join('×');
}
export function isInteractiveLod(sampleDistanceLod) {
    return sampleDistanceLod > 1 + 1e-2;
}
export function formatFactor(value) {
    const rounded = Math.round(value);
    if (Math.abs(value - rounded) < 1e-6) {
        return String(rounded);
    }
    return value.toFixed(1);
}
